import { useEffect } from 'react';

export const useSurveyWidget = (callback) => {
  useEffect(() => {
    const listener = ({ data }: MessageEvent) => {
      const { source, payload } = data;

      if (source !== 'news-survey') return;

      const { surveyId, height } = payload;

      const selector = `[data-survey-id="${surveyId}"]`;
      const surveyElements = document.querySelectorAll(selector);
      surveyElements.forEach((survey) => survey.setAttribute('height', height));
      callback();
    };

    window.addEventListener('message', listener);

    return () => window.removeEventListener('message', listener);
  }, [callback]);
};
